/* eslint-disable max-len */
export default {
  methods: {
    getPlanDetails() {
      return {
        legend: 'General',
        headerName: 'General',
        fields: [
          {
            type: 'customRichText',
            label: '<span class="label-name">Location and Watershed Context</span><br/><span class="help-text">Describe project location and pertinent watershed information (5 characters or more)</span>',
            model: 'locationWatershedContext',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Location and Watershed Context must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Prioritization Context</span><br/><span class="help-text">Describe elements that will impact prioritization of the project (5 characters or more)</span>',
            model: 'prioritizationContext',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Prioritization Context must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Project Rationale</span><br/><span class="help-text">Indicate the key drivers and benefits for doing the project (5 characters or more)</span>',
            model: 'projectRationale',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Project Rationale must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Project Outcomes</span><br/><span class="help-text">Describe the project goals as specific desired outcomes</span>',
            model: 'projectOutcomes',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Alternatives</span><br/><span class="help-text">Describe options for project strategy</span>',
            model: 'alternatives',
            visible: (model) => model && model.category && model.category.includes(' Direct FA '),
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Recommendations</span><br/><span class="help-text">Indicate your recommended option for the project</span>',
            model: 'recommendations',
            visible: (model) => model && model.category && model.category.includes(' Direct FA '),
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Project Actions</span><br/><span class="help-text">Describe the work to be performed (5 characters or more)</span>',
            model: 'projectActions',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Project Actions must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Project Evaluation</span><br/><span class="help-text">Use this section to describe how targets will be evaluated (5 characters or more)</span>',
            model: 'projectEvaluation',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Project Evaluation must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Schedule of Activities</span><br/><span class="help-text">Describe the activities to be performed with chronological context (5 characters or more)</span>',
            model: 'scheduleOfActivities',
            required: true,
            validator: (value) => {
              const errors = [];
              if (!this.validatePlanDetailsNarrative(value)) {
                errors.push('Schedule of Activities must be five or more characters!');
              }
              return errors;
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row assessment-text',
          },
        ],
      };
    },
    getIncentivePaymentSchemaAdd() {
      return {
        id: 'incentivePaymentSchema',
        legend: 'Incentive Payment',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Incentive Type</span>',
            model: 'incentiveTypeId',
            required: true,
            styleClasses: 'row',
            values: this.projectIncentiveTypes,
          },
          {
            type: 'radios',
            label: '<span class="label-name">Vendor Type</span>',
            model: 'vendorType',
            required: true,
            listbox: true,
            styleClasses: 'row',
            values: this.vendorTypes,
          },
          {
            type: 'select',
            label: '<span class="label-name">Payee</span>',
            model: 'payeeId',
            required: true,
            styleClasses: 'row',
            values: this.payees,
            visible: (model) => model.vendorType && model.vendorType === 'Individual Contact',
          },
          {
            type: 'select',
            label: '<span class="label-name">Payee</span>',
            model: 'payeeOrgId',
            required: true,
            styleClasses: 'row',
            values: this.payeesOrgs,
            visible: (model) => model.vendorType && model.vendorType === 'Organization',
          },
          {
            type: 'select',
            label: '<span class="label-name">Funding Source</span>',
            model: 'fundingSourceId',
            required: true,
            styleClasses: 'row',
            values: this.projectFundingSources,
          },
          {
            type: 'customDatepicker',
            label: '<span class="label-name">Due Date</span>',
            model: 'dateDue',
            required: true,
            validator: (value) => {
              if (new Date(value) < new Date(this.project.startDate)) {
                return [`Due Date may not be earlier than ${new Date(this.project.startDate).toLocaleDateString()}!`];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Payment Amount</span>',
            model: 'amountPaid',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimal, greater than 0'];
              }
              return [];
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'textArea',
            label: '<span class="label-name">Notes</span></span><br/><span class="help-text">(Max 100 characters)</span>',
            placeholder: 'Enter Notes here',
            max: 100,
            model: 'notes',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
    },
    getIncentivePaymentSchemaUpdate() {
      return {
        id: 'incentivePaymentSchema',
        legend: 'Incentive Payment',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Incentive Type</span>',
            model: 'incentiveTypeId',
            required: true,
            styleClasses: 'row',
            values: this.projectIncentiveTypes,
          },
          {
            type: 'customDatepicker',
            label: '<span class="label-name">Due Date</span>',
            model: 'dateDue',
            required: true,
            validator: (value) => {
              if (new Date(value) < new Date(this.project.startDate)) {
                return [`Due Date may not be earlier than ${new Date(this.project.startDate).toLocaleDateString()}!`];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            type: 'customDatepicker',
            label: '<span class="label-name">Date Paid</span><br/><span class="help-text">Indicate the date the Landowner Payment was made</span>',
            model: 'datePaid',
            required: true,
            validator: (value) => {
              if (new Date(value) < new Date(this.project.startDate)) {
                return [`Date Paid may not be earlier than ${new Date(this.project.startDate).toLocaleDateString()}!`];
              }
              return [];
            },
            styleClasses: 'row full-width-label',
          },
          {
            type: 'radios',
            label: '<span class="label-name">Vendor Type</span>',
            model: 'vendorType',
            required: true,
            listbox: true,
            styleClasses: 'row',
            values: this.vendorTypes,
          },
          {
            type: 'select',
            label: '<span class="label-name">Payee</span>',
            model: 'payeeId',
            required: true,
            styleClasses: 'row',
            values: this.payees,
            visible: (model) => model.vendorType && model.vendorType === 'Individual Contact',
          },
          {
            type: 'select',
            label: '<span class="label-name">Payee</span>',
            model: 'payeeOrgId',
            required: true,
            styleClasses: 'row',
            values: this.payeesOrgs,
            visible: (model) => model.vendorType && model.vendorType === 'Organization',
          },
          {
            type: 'select',
            label: '<span class="label-name">Funding Source</span>',
            model: 'fundingSourceId',
            required: true,
            styleClasses: 'row',
            values: this.projectFundingSources,
          },
          {
            type: 'textArea',
            label: '<span class="label-name">Notes</span></span><br/><span class="help-text">(Max 100 characters)</span>',
            placeholder: 'Enter Notes here',
            max: 100,
            model: 'notes',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
    },
    getPracticeSchema() {
      return {
        id: 'practiceSchema',
        legend: 'Practice',
        headerName: 'Practice',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Practice</span>',
            model: 'practiceId',
            required: true,
            styleClasses: 'row',
            values: this.practices,
          },
          {
            type: 'select',
            label: '<span class="label-name">Component</span>',
            model: 'practiceComponentId',
            required: true,
            styleClasses: 'row',
            values: () => this.practiceComponentsFiltered,
          },
          {
            type: 'radios',
            label: '<span class="label-name">Target Season</span>',
            model: 'targetSeasonId',
            listbox: true,
            styleClasses: 'row',
            values: this.targetSeasons.sort(
              (a, b) => a.sortOrder - b.sortOrder,
            ).map(
              (ts) => ({ name: ts.name, value: ts.id }),
            ),
          },
          {
            type: 'customYearpicker',
            label: '<span class="label-name">Target Year</span>',
            model: 'targetYear',
            required: true,
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            label: '<span class="label-name">Unit(s)/Fields(s)</span>',
            placeholder: 'Enter Unit(s) or Field(s) this Practice applies to',
            model: 'unitsFields',
            required: true,
            validator: 'required',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Acres</span>',
            model: 'acres',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimal, greater than 0'];
              }
              return [];
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'textArea',
            label: '<span class="label-name">Notes</span></span><br/><span class="help-text">(Max 50 characters)</span>',
            placeholder: 'Enter Notes here',
            max: 50,
            model: 'notes',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
    },
    getConceptSchema() {
      return {
        id: 'conceptSchema',
        legend: 'Concept',
        headerName: 'Concept',
        fields: [
          {
            type: 'customLookupChecklist',
            label: '<span class="label-name">Resource Priorities</span><br/><span class="help-text">Select at least one resource priority</span>',
            model: 'resourcePriorityIds',
            required: true,
            listbox: true,
            values: this.projectResourcePriorities,
            checklistOptions: {
              value: 'id',
              name: 'name',
            },
            styleClasses: 'project-resource-priorities form-group-project-concept',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Estimated Project Cost</span><br/><span class="help-text">Enter an estimated cost for this project</span>',
            model: 'estimatedCost',
            required: true,
            validator: (value) => {
              if (Number.isNaN(value)) return ['Enter a non-negative integer'];
              if (value < 0) return ['Non-negative numbers only'];
              if (value === 0) return [];
              const regex = /^\d+$/;
              if (!regex.test(value)) {
                return ['No decimals allowed'];
              }
              return [];
            },
            styleClasses: 'form-group-project-concept',
          },
          {
            type: 'textArea',
            label: '<span class="label-name">Project Concept Statement</span><br/><span class="help-text">Describe the concept for this project (Min 50 characters)</span>',
            placeholder: 'Enter Project Concept Statement here',
            min: 50,
            model: 'statement',
            required: true,
            styleClasses: 'form-group-project-concept',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Ranking Score</span><br/><span class="help-text">Enter the Ranking Score this project</span>',
            model: 'rankingScore',
            required: true,
            validator: (value) => {
              if (Number.isNaN(value)) return ['Enter a non-negative integer'];
              if (value < 0) return ['Non-negative numbers only'];
              if (value === 0) return [];
              if (value > 999) return ['Three or fewer digits only'];
              const regex = /^\d+$/;
              if (!regex.test(value)) {
                return ['No decimals allowed'];
              }
              return [];
            },
            styleClasses: 'form-group-project-concept',
          },
        ],
      };
    },
    getProjectWorkOrderBillSchema() {
      return {
        id: 'projectWorkOrderBillAddSchema',
        legend: 'Add Bill',
        fields: [
          {
            id: 'invoiceNumber',
            type: 'input',
            inputType: 'text',
            label: '<span class="label-name">Invoice Number</span>',
            placeholder: 'Enter Invoice Number',
            max: 50,
            model: 'billIdentifier',
            required: true,
            validator: ['string', 'required'],
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            id: 'billDate',
            type: 'customDatepicker',
            label: '<span class="label-name">Bill Date</span>',
            model: 'billDate',
            required: true,
            validator: (value) => {
              if (new Date(value) > new Date()) {
                return ['Bill Date cannot be a future date!'];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            id: 'receivedDate',
            type: 'customDatepicker',
            label: '<span class="label-name">Received Date</span>',
            model: 'receivedDate',
            required: true,
            validator: (value) => {
              if (new Date(value) > new Date()) {
                return ['Received Date cannot be a future date!'];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            id: 'notes',
            type: 'textArea',
            label: '<span class="label-name">Notes</span></span><br/><span class="help-text">(Max 75 characters)</span>',
            placeholder: 'Enter Notes here',
            max: 75,
            model: 'notes',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
    },
    getProjectWorkorderAddSchema() {
      let schema = {};
      if (this.workorderAddModel) {
        schema = {
          id: 'projectWorkOrderAddSchema',
          legend: 'Add Work Order',
          fields: [
            {
              type: 'select',
              label: '<span class="label-name">Contract</span><br/><span class="help-text">This selection indicates the Price Book to be used for cost items.</span>',
              model: 'opportunityId',
              required: true,
              styleClasses: 'row',
              values: this.workorderAddModel.opportunityBriefs,
            },
            {
              id: 'workorderName',
              type: 'input',
              inputType: 'text',
              label: '<span class="label-name">Work Order Name</span><br/><span class="help-text">(Enter at least one character)</span>',
              placeholder: 'Enter Work Order Name',
              model: 'workorderName',
              required: true,
              min: 1,
              validator: ['string'],
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
            },
            {
              id: 'requestedDate',
              type: 'customDatepicker',
              label: `<span class="label-name">Requested Work Completion Date</span><br/><span class="help-text">(Must be in fiscal year ${this.workorderAddModel.fiscalYear})</span>`,
              model: 'requestedDate',
              disabledDates: {
                to: this.workorderAddModel.fiscalYearStart,
                from: this.workorderAddModel.fiscalYearEnd,
              },
              required: true,
              validator: (value) => {
                if (new Date(value) < this.workorderAddModel.fiscalYearStart) return [`Requested Work Completion date may not be earlier than ${new Date(this.workorderAddModel.fiscalYearStart).toLocaleDateString()}`];
                if (new Date(value) >= this.workorderAddModel.fiscalYearEnd) return [`Requested Work Completion date must be earlier than ${new Date(this.workorderAddModel.fiscalYearEnd).toLocaleDateString()}`];
                return [];
              },
              styleClasses: 'row',
            },
            {
              type: 'radios',
              label: '<span class="label-name">Vendor Type</span>',
              model: 'vendorType',
              required: true,
              listbox: true,
              styleClasses: 'row',
              values: this.workorderAddModel.vendorTypes,
            },
            {
              type: 'customSelect',
              label: '<span class="label-name">Vendor Contact</span><br/><span class="help-text">(Select one)</span>',
              model: 'vendorContact',
              required: true,
              styleClasses: 'row',
              values: this.workorderAddModel.vendorContacts,
              visible: (model) => model.vendorType && model.vendorType === 'Individual Contact',
            },
            {
              type: 'customSelect',
              label: '<span class="label-name">Vendor Organization</span><br/><span class="help-text">(Select one)</span>',
              model: 'vendorOrganization',
              required: true,
              styleClasses: 'row',
              values: this.workorderAddModel.vendorOrganizations,
              visible: (model) => model.vendorType && model.vendorType === 'Organization',
            },
            {
              id: 'contractorSpecialInstructions',
              type: 'textArea',
              label: '<span class="label-name">Contractor Special Instructions</span>',
              placeholder: 'Enter Contractor Special Instructions here',
              max: 3000,
              model: 'contractorSpecialInstructions',
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
            },
          ],
        };
      }
      return schema;
    },
    getProjectWorkorderEditSchema() {
      let schema = {};
      if (this.workorderEditModel) {
        schema = {
          id: 'projectWorkOrderEditSchema',
          legend: 'Edit Work Order',
          fields: [
            {
              id: 'workorderName',
              type: 'input',
              inputType: 'text',
              label: '<span class="label-name">Work Order Name</span><br/><span class="help-text">(Enter at least one character)</span>',
              placeholder: 'Enter Work Order Name',
              model: 'workorderName',
              required: true,
              min: 1,
              validator: ['string'],
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
            },
            {
              id: 'requestedDate',
              type: 'customDatepicker',
              label: `<span class="label-name">Requested Work Completion Date</span><br/><span class="help-text">(Must be in fiscal year ${this.workorderEditModel.fiscalYear})</span>`,
              model: 'requestedDate',
              disabledDates: {
                to: this.workorderEditModel.fiscalYearStart,
                from: this.workorderEditModel.fiscalYearEnd,
              },
              required: true,
              validator: (value) => {
                if (new Date(value) < this.workorderEditModel.fiscalYearStart) return [`Requested Work Completion date may not be earlier than ${new Date(this.workorderEditModel.fiscalYearStart).toLocaleDateString()}`];
                if (new Date(value) >= this.workorderEditModel.fiscalYearEnd) return [`Requested Work Completion date must be earlier than ${new Date(this.workorderEditModel.fiscalYearEnd).toLocaleDateString()}`];
                return [];
              },
              styleClasses: 'row',
            },
            {
              type: 'radios',
              label: '<span class="label-name">Vendor Type</span>',
              model: 'vendorType',
              required: true,
              listbox: true,
              styleClasses: 'row',
              values: this.workorderEditModel.vendorTypes,
              disabled: this.workorderEditModel.status !== 'Draft',
            },
            {
              type: 'customSelect',
              label: '<span class="label-name">Vendor Contact</span><br/><span class="help-text">(Select one)</span>',
              model: 'vendorContact',
              required: true,
              styleClasses: 'row',
              values: this.workorderEditModel.vendorContacts,
              disabled: this.workorderEditModel.status !== 'Draft',
              visible: (model) => this.workorderEditModel.status === 'Draft' && model.vendorType && model.vendorType === 'Individual Contact',
            },
            {
              type: 'input',
              inputType: 'text',
              label: '<span class="label-name">Vendor Contact</span>',
              model: 'vendorContact.name',
              min: 1,
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
              disabled: true,
              visible: (model) => this.workorderEditModel.status !== 'Draft' && model.vendorType && model.vendorType === 'Individual Contact',
            },
            {
              type: 'customSelect',
              label: '<span class="label-name">Vendor Organization</span><br/><span class="help-text">(Select one)</span>',
              model: 'vendorOrganization',
              required: true,
              styleClasses: 'row',
              values: this.workorderEditModel.vendorOrganizations,
              disabled: this.workorderEditModel.status !== 'Draft',
              visible: (model) => this.workorderEditModel.status === 'Draft' && model.vendorType && model.vendorType === 'Organization',
            },
            {
              type: 'input',
              inputType: 'text',
              label: '<span class="label-name">Vendor Contact</span>',
              model: 'vendorOrganization.name',
              min: 1,
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
              disabled: true,
              visible: (model) => this.workorderEditModel.status !== 'Draft' && model.vendorType && model.vendorType === 'Organization',
            },
            {
              id: 'contractorSpecialInstructions',
              type: 'textArea',
              label: '<span class="label-name">Contractor Special Instructions</span>',
              placeholder: 'Enter Contractor Special Instructions here',
              max: 3000,
              model: 'contractorSpecialInstructions',
              attributes: {
                wrapper: { 'data-list': 'col-5' },
              },
              styleClasses: 'row',
            },
          ],
        };
      }
      return schema;
    },
    getProjectWorkorderLineItemAddSchema() {
      const schema = {
        id: 'projectWorkorderLineItemAddSchema',
        legend: 'Add Line Item',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Funding Source</span>',
            model: 'fundingSourceId',
            required: true,
            styleClasses: 'row',
            values: this.workorderLineItemAddFundingSources,
          },
          {
            type: 'select',
            label: '<span class="label-name">Service/Material</span>',
            model: 'pricebookEntryId',
            required: true,
            styleClasses: 'row',
            values: this.workorderLineItemPricelistEntries,
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Unit Cost</span>',
            model: 'unitCost',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimal, greater than 0'];
              }
              return [];
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Quantity</span>',
            model: 'quantity',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimals, greater than 0'];
              }
              return [];
            },
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            disabled: true,
            label: '<span class="label-name">Item Cost</span>',
            model: 'itemCost',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">% District or Partner Cost</span>',
            model: 'districtAndPartnerCost',
            required: true,
            validator: (value) => (this.validatePositiveWholeNumber(value, 100)),
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            disabled: true,
            label: '<span class="label-name">District or Partner Cost</span>',
            model: 'districtAndPartnerCostValue',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
      return schema;
    },
    getProjectWorkorderLineItemEditSchema() {
      const schema = {
        id: 'projectWorkorderLineItemEditSchema',
        legend: 'Edit Line Item',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Funding Source</span>',
            model: 'fundingSourceId',
            required: true,
            values: this.workorderLineItemEditFundingSources,
            styleClasses: 'project-workorder-lineitem-edit-funding-source-style row',
            labelClasses: 'project-workorder-lineitem-edit-funding-source-label',
            fieldClasses: 'project-workorder-lineitem-edit-funding-source-field col- ',
          },
          {
            type: 'checkbox',
            label: '<span class="label-name">Apply funding source to all items</span>',
            model: 'applyToAll',
            default: false,
            styleClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-style row',
            labelClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-label',
            fieldClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-field col- ',
          },
          {
            type: 'select',
            label: '<span class="label-name">Service/Material</span>',
            model: 'pricebookEntryId',
            required: true,
            values: this.workorderLineItemPricelistEntries,
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Unit Cost</span>',
            model: 'unitCost',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimal, greater than 0'];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Quantity</span>',
            model: 'quantity',
            required: true,
            validator: (value) => {
              if (!value) return ['This field is required'];
              const regex = /^(\d+)?([.]?\d{0,2})?$/;
              if (!regex.test(value)) {
                return ['Numeric field, up to 2 decimal, greater than 0'];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            disabled: true,
            label: '<span class="label-name">Item Cost</span>',
            model: 'itemCost',
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">% District or Partner Cost</span>',
            model: 'districtAndPartnerCost',
            required: true,
            validator: (value) => (this.validatePositiveWholeNumber(value, 100)),
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            disabled: true,
            label: '<span class="label-name">District or Partner Cost</span>',
            model: 'districtAndPartnerCostValue',
            styleClasses: 'row',
          },
        ],
      };
      return schema;
    },
    getProjectWorkorderIncentivePaymentAddSchema() {
      const schema = {
        id: 'projectWorkorderIncentivePaymentAddSchema',
        legend: 'Add Incentive Payment',
        fields: [
          {
            type: 'select',
            label: '<span class="label-name">Incentive Payment</span>',
            model: 'incentivePaymentId',
            required: true,
            styleClasses: 'row',
            values: this.incentivePayments,
          },
        ],
      };
      return schema;
    },
    validatePositiveWholeNumber(value, maxValue) {
      // https://stackoverflow.com/questions/12702030/regular-expression-for-3-decimal-point
      if (value === null || Number.isNaN(value)) return ['Must enter a numeric value!'];
      if (value < 0) return ['Non-negative numbers only!'];
      if (value > maxValue) return [`Cannot exceed ${maxValue}!`];
      if (value.toString().match(/\.[0-9]{1}/)) return ['No decimal places allowed!'];
      return [];
    },
    getProjectOutcomesSchema() {
      const schema = {
        id: 'projectOutcomesSchema',
        legend: 'Edit Outcome Summary',
        fields: [
          {
            id: 'outcomeSummary',
            type: 'textArea',
            label: '<span class="label-name">Outcome Summary</span>',
            placeholder: 'Enter Outcome Summary here',
            max: 2000,
            model: 'outcomeSummary',
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
        ],
      };
      return schema;
    },
    getProjectTargetMonitoringEventAddSchema() {
      const schema = {
        id: 'projectTargetMonitoringEventAddSchema',
        legend: 'Add Monitoring Event',
        fields: [
          {
            id: 'monitoringEventDate',
            type: 'customDatepicker',
            label: '<span class="label-name">Monitoring Date</span>',
            model: 'monitoringEventDate',
            required: true,
            validator: (value) => {
              if (new Date(value) > new Date()) {
                return ['Monitoring Date cannot be a future date!'];
              }
              return [];
            },
            styleClasses: 'row',
          },
          {
            type: 'customSelect',
            label: '<span class="label-name">Evaluation Method</span>',
            model: 'monitoringEventEvaluationMethod',
            required: true,
            values: this.projectTargetMonitoringEventAddModelEvaluationMethods,
            styleClasses: 'row',
          },
          {
            type: 'radios',
            label: '<span class="label-name">Evaluation Yes/No</span>',
            model: 'monitoringEventEvaluationBit',
            values: (model) => [{ name: `Yes (${model.monitoringEventEvaluationMethod.unit})`, value: true }, { name: `No (${model.monitoringEventEvaluationMethod.unit})`, value: false }],
            required: true,
            visible: (model) => (model.monitoringEventEvaluationMethod !== null) && (model.monitoringEventEvaluationMethodType === 'Bit'),
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Evaluation Quantity</span>',
            model: 'monitoringEventEvaluationNumber',
            required: true,
            validator: (value) => {
              if (value === null || Number.isNaN(value)) return ['Evaluation Number may not be null!'];
              if (value.toString().split('.').length === 2 && value.toString().split('.')[1].length > 2) {
                return ['Evaluation Number decimal places must be two or fewer!'];
              }
              return [];
            },
            visible: (model) => (model.monitoringEventEvaluationMethod !== null) && (model.monitoringEventEvaluationMethodType === 'Number'),
            styleClasses: 'project-workorder-lineitem-edit-funding-source-style row',
            labelClasses: 'project-workorder-lineitem-edit-funding-source-label',
            fieldClasses: 'project-workorder-lineitem-edit-funding-source-field col- ',
          },
          {
            type: 'input',
            inputType: 'text',
            label: '<span class="label-name">Evaluation Text</span>',
            model: 'monitoringEventEvaluationText',
            required: true,
            minLength: 2,
            maxLength: 100,
            validator: (value) => {
              if (!value || value === null) return ['Evaluation Text may not be empty!'];
              if (value.length < 2) return ['Minimum length is 2!'];
              if (value.length > 100) return ['Maximum length is 100!'];
              return [];
            },
            visible: (model) => (model.monitoringEventEvaluationMethod !== null) && (model.monitoringEventEvaluationMethodType === 'Text'),
            styleClasses: 'project-workorder-lineitem-edit-funding-source-style row',
            labelClasses: 'project-workorder-lineitem-edit-funding-source-label',
            fieldClasses: 'project-workorder-lineitem-edit-funding-source-field col- ',
          },
          {
            type: 'input',
            inputType: 'text',
            disabled: true,
            label: '<span class="label-name"></span>',
            model: 'monitoringEventEvaluationMethodUnit',
            visible: (model) => model.monitoringEventEvaluationMethod !== null && (model.monitoringEventEvaluationMethodType !== 'Bit'),
            styleClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-style row',
            labelClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-label',
            fieldClasses: 'project-workorder-lineitem-edit-funding-source-apply-to-all-field col- ',
          },
          {
            type: 'select',
            label: '<span class="label-name">Plant Type</span>',
            model: 'monitoringEventPlantType',
            required: false,
            values: this.projectTargetMonitoringEventAddModelPlantTypes,
            styleClasses: 'row',
          },
          {
            type: 'radios',
            label: '<span class="label-name">Photo Monitored?</span>',
            model: 'monitoringEventPhotoMonitored',
            values: [{ name: 'Yes', value: true }, { name: 'No', value: false }],
            required: true,
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            label: '<span class="label-name">URL Link</span>',
            model: 'monitoringEventUrl',
            required: false,
            maxLength: 150,
            validator: (value) => {
              if (value.length > 150) return ['Maximum length is 150!'];
              return [];
            },
            styleClasses: 'row',
          },
        ],
      };
      return schema;
    },
  },
};
